import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import {makeLogger} from '../../../../logger/logger';
import type {BaseUrlsStrategyData} from '../../types/base-urls-data.type';
import {BaseUrlsStrategyService} from '../../BasePathStrategyService';


const {err} = makeLogger({pathToCurrentFile: 'components/strategies/services/internal-address-services/internal-address-faqs.service.ts'});
@Service({id: 'seBaseUrlsStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<BaseUrlsStrategyService> {

  build(details: BaseUrlsStrategyData): BaseUrlsStrategyService {
      return new SeBaseUrlsStrategyService(details);
  }
}

export class SeBaseUrlsStrategyService extends BaseUrlsStrategyService{
  details: BaseUrlsStrategyData;

  constructor(details: BaseUrlsStrategyData) {
      super();
      this.details = details;
  }
  getBaseUrls(): BaseUrlsStrategyData {
      return this.details;
  }
}
